import { AxiosResponse } from 'axios';
import { $api } from '@partnerka-front/api';
import { PostbackFieldEnumDto } from '@partnerka-front/types';

const basePath = '/postback_field_enum';

export async function getPostbackFieldEnum(): Promise<AxiosResponse<PostbackFieldEnumDto[]>> {
  return $api.get(`${basePath}/`);
}
